import React from "react";
import { message, Button, Table, Select, Input } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import css from './index.css';
import { hasAuth, createUuid } from "../../../utils/NHCore";

const Search = Input.Search;

export default class Xsxxcjcx extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            valiteColumns: [],
            dmkmcList:{}
        }
    }

    componentDidMount() {
        NHFetch('/xxcj/bdgl/getValiteColumns', 'GET').then(res => {
            if (res && res.data && res.data.length > 0) {
                console.log(res.data)
                this.setState({ valiteColumns: res.data });
            } else {
                message.warning('当前未配置学生采集信息项');
            }
        }).catch((error) => {
            message.error('服务器异常！');
        });
    }

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => {
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('学生采集信息');
    }

    render() {

        const { valiteColumns } = this.state;
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
                fixed: 'left'
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                fixed: 'left',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                fixed: 'left',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                fixed: 'left',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                fixed: 'left',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select"
            }
        ];

        let extraColumns = [];
        if (valiteColumns && valiteColumns.length > 0) {
            valiteColumns.forEach((item) => {
                const {zdmc = null,zdbz = null,kjcs} = item?item:{zdmc:null,zdbz:null}; 
                let column = {
                    title: zdmc,
                    width: parseInt(zdmc?zdmc.length:0) * 20 + 40 + 'px',
                    dataIndex: zdbz?zdbz.toUpperCase():null,
                    key: zdbz?zdbz.toLowerCase():null
                    /*render: (text, record) => {

                        let zdz = record[zdbz];
                        let kjcsjson = JSON.parse(kjcs);
                        let zdzmc = '';
                        if (kjcsjson.type === "select") {
                            if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                                this.getDmkMc(kjcsjson.dataTag, zdbz);
                            }
                            let list = this.state.dmkmcList[zdbz];
                            list && list.map(item => {
                                if (item.VALUE === zdz) {
                                    zdzmc = item.LABEL;
                                }
                            })
                        } else
                            if (kjcsjson.type === "switch") {
                                if(zdz==='1' || zdz === true){
                                    zdzmc = kjcsjson.checkedText;
                                }else if(zdz==='0' || zdz === false){
                                    zdzmc = kjcsjson.uncheckedText;
                                }else{
                                    zdzmc = "";
                                }
                            }
                            else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map((item, key) => {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                })
                            }
                            else {
                                zdzmc = zdz;
                            }
                        return zdzmc;
                    }*/
                };
                if(column.title){
                    extraColumns.push(column);
                }
            });
        }
        let maxSearchTitle = 2;
        let searchLength = 0;
        let tyOptions = columnConst.map((item, index) => {
            if (item.commonSearch !== false && item.title != '序号' && item.title != '操作') {
                searchLength++;
                if (item.title.length > maxSearchTitle) {
                    maxSearchTitle = item.title.length;
                }
                return <Select.Option value={item.dataIndex} key={createUuid()}>{item.title}</Select.Option>
            } else {
                return '';
            }
        })

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                {
                    extraColumns.length > 0 && extraColumns ?
                        undefined
                        :
                        <div id='homeSearchDiv' style={{ marginBottom: '16px' }}>
                            <Select
                                value="all"
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{ width: (tyOptions && searchLength > 6) ? (80 + (maxSearchTitle - 2) * 15) : 'auto' }}
                            >
                                <Select.Option value="all">全部</Select.Option>
                                {
                                    tyOptions
                                }
                            </Select>
                            <Search
                                placeholder="请输入查询条件"
                                style={{ width: 230 }}
                            />
                            <Button type="primary" style={{ margin: '0 20px' }}>查询</Button>
                            <Button type="Default" style={{ paddingLeft: 5 }} ghost icon="reload">重置</Button>
                        </div>
                }

                <div style={{ width: '100%', height: '100%', }}>
                    {extraColumns.length > 0 && extraColumns ?
                        <NHTable ref='nhTable'
                            rowKey={record => record.PKID}
                            sign={"zhxg_yxxt_tjcx_xscjxx_queryPage"}
                            columns={columnConst.concat(extraColumns)}
                            sqlParams={{xxcjSign:'zhxg_yxxt_xscjxxzd'}}
                            rangeFilter={true}
                        >
                            {hasAuth("zhxg_yxgl_tjcx_xsxxcjcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                        </NHTable>
                        :
                        <Table ref='nhTableNone'
                            columns={columnConst.concat(extraColumns)}
                            size="small"
                            bordered
                        >
                        </Table>
                    }
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./components/tjcx/xsxxcjcx/index.js